// The marketplaces MARQIT supports, in display order, and the sections every marketplace
// screen has. Sidebar submenu and the in-page tab bar are built from the same list.
export const MARKETPLACES = ['wildberries', 'ozon', 'yandex_market'];

export const MP_SECTIONS = [
  { key: '', label: 'Аналитика' },
  { key: 'reports', label: 'Отчёты' },
  { key: 'costs', label: 'Себестоимость и налоги' },
  { key: 'stocks', label: 'Остатки' },
  { key: 'calculator', label: 'Калькулятор' },
  { key: 'promotions', label: 'Акции' },
  { key: 'connections', label: 'Подключения' },
];

export const mpPath = (marketplace, section = '') => `/mp/${marketplace}${section ? `/${section}` : ''}`;

// Sections with full analytics (reports, stocks, calculator, promotions, costs) exist for
// Wildberries only.
export const hasData = (marketplace) => marketplace === 'wildberries';

// Marketplaces whose data MARQIT loads in the background (loading page, dashboard, the
// «Аналитика» section). Ozon's other sections arrive later. Yandex Market is connect-only.
export const hasSync = (marketplace) => marketplace === 'wildberries' || marketplace === 'ozon';

// Prefix of the marketplace's product id in the UI: WB article (nm_id) or Ozon SKU.
export const idPrefix = (marketplace) => (marketplace === 'ozon' ? 'SKU' : 'WB');

export const isKnownMarketplace = (mp) => MARKETPLACES.includes(mp);
